module.exports = __webpack_public_path__ + "static/media/AB_Z10_3.52771d1b.jpg";